
import Msg from 'vux/src/components/msg/index.vue'
import Divider from 'vux/src/components/divider/index.vue'
import XButton from 'vux/src/components/x-button/index.vue'

export default {
components: {
Msg,
Divider,
XButton
},
data() {
return {
activeId: "",
icon: "warn",
title: "访问错误",
description:
'您访问的活动不存在！',







};
},
async mounted() {
this.activeId = this.$route.params.activeId;
if (!this.activeId) {
this.activeId = this.$route.params.id;
}

},
methods: {
}
};



// WEBPACK FOOTER //
// ./src/components/error.vue